import { collection, getDocs, getFirestore } from 'firebase/firestore';
import './App.css';
import Layout from './components/Layout';
import { getAccount, uploadImage } from './supabase';
import { useEffect, useState } from 'react'; 
function Profilo() {
    const [account, setAccount] = useState([{}])

    useEffect(() => {
        const get = async () => {
            const data = await getAccount(localStorage.getItem('mail'))
            await setAccount(data)
            console.log(data)
        }
        get()
    }, [])
 



    return (
        <Layout>
            <div className='flex w-full h-full flex-col overflow-scroll'>
                <div className='flex flex-1 flex-col'>
                    <div className='flex flex-col items-center mt-4'>
                        <div className='flex flex-row items-center w-1/3 justify-around'>
                            <div className=" border-[#D28740] border-4 rounded-full w-8 h-auto aspect-square flex justify-center items-center text-center">
                                <p className='text-white font-bold text-base w-fit'>{account[0]?.medaglie?.bronzo}</p>
                            </div>
                            <div className=" border-[#BFBFBF] border-4 rounded-full w-8 h-auto aspect-square flex justify-center items-center text-center">
                                <p className='text-white font-bold text-base w-fit'>{account[0]?.medaglie?.argento}</p>
                            </div>
                            <div className=" border-[#FBD10F] border-4 rounded-full w-8 h-auto aspect-square flex justify-center items-center text-center">
                                <p className='text-white font-bold text-base w-fit'>{account[0]?.medaglie?.oro}</p>
                            </div>
                        </div>
                        <div className='flex flex-col mt-6 items-center'>
                            <h2 className='text-2xl font-bold text-white'>{account[0]?.nickname}</h2>
                            <h2 className='text-xl font-normal text-[#FFFFFF80]'>{account[0]?.nome}</h2>
                        </div>

                        <div className='flex w-full items-start flex-col mt-8'>

                        <div className='flex w-full items-start flex-row justify-between'>
                                <div className='flex flex-1'>
                                    <p className='text-xl font-normal text-[#FFFFFF80]'>Presenze</p>
                                </div>

                                <div className='flex flex-[2]'>
                                    <p className='text-xl font-normal text-white'>{account[0]?.presenze}</p>
                                </div>

                            </div> <div className='flex w-full items-start flex-row justify-between mt-4'>
                                <div className='flex flex-1'>
                                    <p className='text-xl font-normal text-[#FFFFFF80]'>Fondi</p>
                                </div>

                                <div className='flex flex-[2]'>
                                    <p className='text-xl font-normal text-white'>€ {account[0]?.fondi}</p>
                                </div>

                            </div>
                            <div className='flex w-full items-start flex-row justify-between mt-4'>
                                <div className='flex flex-1'>
                                    <p className='text-xl font-normal text-[#FFFFFF80]'>Ruolo</p>
                                </div>

                                <div className='flex flex-[2]'>
                                    <p className='text-xl font-normal text-white'>Ala, Scout, Supporto, Sicurezza</p>
                                </div>

                            </div>

                            <div className='flex w-full items-start flex-row justify-between mt-4'>
                                <div className='flex flex-1'>
                                    <p className='text-xl font-normal text-[#FFFFFF80]'>Equip.</p>
                                </div>

                                <div className='flex flex-[2]'>
                                    <p className='text-xl font-normal text-white'>M4 Specnarms, Pallini Bio, Idrogear chest rig, Caricatori monofilari 220p, Batteria lipo 7.4</p>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>


            </div>

        </Layout>
    );
}

export default Profilo;


